<template>
  <div>
    <el-tabs type="card" v-model="activeName" @tab-click="handleClick" class="common-tab">
      <el-tab-pane label="待办任务" name="todo">
        <Todo />
      </el-tab-pane>
      <el-tab-pane label="已办任务" name="done">
        <Done />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import Todo from './todo';
  import Done from './done';
  export default {
    name: 'list',
    components: {
      Todo,
      Done,
    },
    data() {
      return {
        activeName: 'todo',
      };
    },
    mounted() {
      if (this.$route.query?.status) {
        this.activeName = this.$route.query.status;
      }
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      },
    },
  };
</script>

<style scoped>
  ::v-deep .sirui-search {
    margin-top: 10px;
  }
</style>
